/* eslint-disable */ import noop from 'lodash/noop.js';
import get from 'lodash/get.js';
const BASE_URL = '/';
export default ((inca)=>({
        getBaseUrl () {
            return BASE_URL;
        },
        on: function() {
            let _events = {};
            let registerEventFn = function(event, callback) {
                if (!_events[event]) {
                    _events[event] = [];
                }
                _events[event].push(callback);
            };
            registerEventFn.trigger = function(event) {
                let events = _events[event] || [];
                events.forEach((x)=>{
                    x();
                });
            };
            return registerEventFn;
        }(),
        "scriptSupport": {},
        "services": {
            "infoText": {},
            logging: {
                logError (...args) {
                    console.log('Logging to INCA:', ...args);
                }
            },
            report: {
                getUrlByShortName (shortname) {
                    return `${BASE_URL}Sammanstallning/ShowReport.aspx?ShortName=${encodeURIComponent(shortname)}&ContentOnly=true`;
                }
            },
            "viewTemplate": {
                getById (opt) {
                    let { id, error, success, ...options } = opt;
                    fetch(`/api/ViewTemplates/${id}/Data`, {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        credentials: 'same-origin',
                        body: JSON.stringify(options)
                    }).then((res)=>{
                        return res.json();
                    }).then((data)=>{
                        (success || noop)(data);
                    }, (err)=>{
                        (error || noop)(err);
                    });
                }
            },
            startPage: {
                getValueDomainValues (options) {
                    fetch(`/api/StartPages/${get(inca, [
                        'startPage',
                        'id'
                    ], 1)}/ValueDomains/${encodeURIComponent(options.shortname)}`, {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        credentials: 'same-origin',
                        body: JSON.stringify({
                            filters: options.filters,
                            parameters: options.parameters
                        })
                    }).then((res)=>{
                        if (res.ok) {
                            return res.json();
                        }
                        return Promise.reject(`Error: ${res.status}`);
                    }).then((res)=>{
                        (options.success || noop)(res);
                    }, (err)=>{
                        (options.error || noop)(err);
                    });
                }
            }
        },
        "user": {
            "id": 7909,
            "firstName": "Kalle",
            "lastName": "Testsson",
            "username": "testuser",
            "email": "test.user@test.com",
            "phoneNumber": null,
            "role": {
                "id": 43,
                "name": "Inrapportör (Patientöversikt)",
                "isReviewer": true
            },
            "position": {
                "id": 39,
                "name": "Onkologiska kliniken",
                "code": "741",
                "fullNameWithCode": "OC Demo (0) - SU/Sahlgrenska (500010) - Onkologiska kliniken (741)"
            },
            "region": {
                "id": 7,
                "name": "Region Demo"
            },
            "previousLogin": "2015-11-05T15:09:32.48Z"
        },
        "serverDate": "2015-11-06T08:59:27.338Z",
        ...inca
    }));
